import { render } from "./location-map.vue?vue&type=template&id=545406a6"
import script from "./location-map.vue?vue&type=script&lang=js"
export * from "./location-map.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__